const testConfig = {
  baseUrl: 'https://test-node.dimorder.com/c/merchant/landing?from=landing&l=zh',
}

export default testConfig
